import { Component, inject } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { Router } from '@angular/router';
import { CommonService } from '../services/common.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent {
  private authService = inject(AuthService);
  private router = inject(Router);
  private commonService = inject(CommonService);
  
  email: string = '';
  isSubmitted: boolean = false;
  isLoading: boolean = false;

  onSubmit() {
    this.isSubmitted = true;
    if (!this.email || !this.isValidEmail(this.email)) return;
    this.isLoading = true;
    this.authService.forgotPassword(this.email).subscribe({
      next: () => this.handleSuccess(),
      error: (error) => this.handleError(error)
    });
  }

  private handleSuccess() {
    this.isLoading = false;
    this.commonService.openSnackBar('Credentials sent to your email address.');
    this.resetForm();
    this.router.navigate(['/login']);
  }

  private handleError(error: any) {
    this.isLoading = false;
    this.commonService.openSnackBar('Failed to send credentials. Please try again.');
  }

  private resetForm() {
    this.email = '';
    this.isSubmitted = false;
  }

  isValidEmail(email: string): boolean {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }
}